<mat-toolbar color="accent">Create Role</mat-toolbar>

<form [formGroup]="roleForm" (ngSubmit)="submit()">
  <mat-dialog-content fxLayout="column">
    <mat-form-field fxFlex>
      <mat-label>Name</mat-label>
      <input matInput formControlName="name" />
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions>
    <pt-buttons-container padding="none">
      <button mat-stroked-button mat-dialog-close>Cancel</button>
      <button mat-flat-button color="primary" [disabled]="roleForm.invalid">
        Create
      </button>
    </pt-buttons-container>
  </mat-dialog-actions>
</form>
